import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ResourceManagerService } from '@barthauer/abc/core/resources';
import { AbcDropDownBoxComponent } from '@barthauer/abc/ui-components';
import { BasysMapFrameService } from '@barthauer/basys/map-frame';
import { ResourceEventEditBase } from '../resource-event-edit-base/resource-event-edit-base.component';
import { ResourcesService } from '../resources.service';

@Component({
  selector: 'app-resource-event-other-other',
  templateUrl: './resource-event-other-other.component.html',
  styleUrls: ['./resource-event-other-other.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class ResourceEventOtherOtherComponent extends ResourceEventEditBase implements OnInit, OnDestroy {
  @ViewChild('resourceEventType', { static: true }) resourceEventType: AbcDropDownBoxComponent;

  constructor(
    resourceManagerService: ResourceManagerService,
    resourcesService: ResourcesService,
    frame: BasysMapFrameService
  ) {
    super();
    super.init(frame, resourcesService, resourceManagerService);
  }

  protected override onNavigationContextRefresh(): void {
    if (!this.resourceEventType.dataSource) {
      this.resourceEventType.setupForArrayData(
        this.resourcesNavigationContext.resourceEventGroup.resourceEventTypeGroup.resourceEventTypes,
        'id',
        'name'
      );
    }
  }

  async ngOnInit() {
    super.ngOnInit();
  }
  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
